module.exports = __webpack_public_path__ + "static/media/02.99492839.jpg";